export var FlowIteratorBlockErrorResolution;
(function (FlowIteratorBlockErrorResolution) {
    /** Log the error and continue with the next iteration */
    FlowIteratorBlockErrorResolution["Continue"] = "Continue";
    /** Fail fast and don't let the workflow engine retry */
    FlowIteratorBlockErrorResolution["Fail"] = "Fail";
    /** Retries will be handled by the temporal workflow engine */
    FlowIteratorBlockErrorResolution["Retry"] = "Retry";
})(FlowIteratorBlockErrorResolution || (FlowIteratorBlockErrorResolution = {}));
//# sourceMappingURL=errorResolution.js.map